import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { Auth0Provider } from '@auth0/auth0-react';
import App from './App.jsx';
import './index.css';
import { AuthProvider } from './contexts/AuthContext';
import { Auth0ContextProvider } from './contexts/Auth0Context';
import { ThemeProvider } from './contexts/ThemeContext';

const auth0Config = {
  domain: import.meta.env.VITE_AUTH0_DOMAIN,
  clientId: import.meta.env.VITE_AUTH0_CLIENT_ID,
  authorizationParams: {
    redirect_uri: import.meta.env.VITE_AUTH0_REDIRECT_URI || `${window.location.origin}/callback`,
    audience: import.meta.env.VITE_AUTH0_AUDIENCE,
    scope: 'openid profile email'
  },
  useRefreshTokens: true,
  cacheLocation: 'localstorage'
};

// Check if Auth0 is configured
const isAuth0Configured = auth0Config.domain && auth0Config.clientId;

console.log('🔐 Auth0 Configuration:', {
  isConfigured: isAuth0Configured,
  domain: auth0Config.domain || 'NOT SET',
  clientId: auth0Config.clientId ? 'SET' : 'NOT SET'
});

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <BrowserRouter>
      {isAuth0Configured ? (
        <Auth0Provider {...auth0Config}>
          <AuthProvider>
            <Auth0ContextProvider>
              <ThemeProvider>
                <App />
              </ThemeProvider>
            </Auth0ContextProvider>
          </AuthProvider>
        </Auth0Provider>
      ) : (
        <AuthProvider>
          <Auth0ContextProvider>
            <ThemeProvider>
              <App />
            </ThemeProvider>
          </Auth0ContextProvider>
        </AuthProvider>
      )}
    </BrowserRouter>
  </React.StrictMode>,
); 